wbApp.controller('PreferredBookingDetailCtrl', ['$scope', '$modal', '$translate', '$timeout', '$filter', 'preferredBookingSvc', 'compensationGroupSvc',
function ($scope, $modal, $translate, $timeout, $filter, preferredBookingSvc, compensationGroupSvc) {

    $scope.isLoading = true;

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "setting/semesters/preferred-booking-detail-main-tab.html"
        },
        {
            title: "TXT_LBL_STUDENTS",
            template: "setting/semesters/preferred-booking-detail-course-registrations-tab.html"
        }
    ];
    $scope.detailTabs.activeTab = 0;

    $scope.$watch('detailTabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue, oldValue: oldValue });
    });

    $scope.model = [];
    compensationGroupSvc.getLookup().$promise.then(function () {
        $scope.model = preferredBookingSvc.getBySemesterID($scope.semesterID);
        $scope.model.$promise.then(function () {
            $scope.isLoading = false;
        });
    })

    $scope.isModelValid = function (model) {
        return !!model.sourceSemestersIDs && !!model.sourceSemestersIDs.length;
    }

    $scope.onFromSemestersChanged = function (model) {
        if (!model.sourceSemestersIDs || model.sourceSemestersIDs.length === 0) {
            model.data.length = 0;            
        } else {
            preferredBookingSvc.getByPreferredBooking(model).$promise.then(function (data) {
                model.data.length = 0;
                model.data.push.apply(model.data, data.data);                
            });
        }
    }

    $scope.isSaving = false;

    $scope.courseRegistrationsGridSettings = {
        columns: [
            { dataField: 'studentFullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', width: '190px', sortOrder: 'asc' },
            {
                dataField: 'firstLesson',
                caption: $translate.instant('TXT_MENU_SCHEDULE'),
                dataType: 'date',
                format: { raw: "EEE HH:mm" },
                calculateSortValue: function (rowData) {
                    var mfirstLesson = moment(rowData.firstLesson);
                    return mfirstLesson.isValid()
                        ? mfirstLesson.day() * 10000 + mfirstLesson.hour() * 100 + mfirstLesson.minute()
                        : rowData.firstLesson;
                },
                width: '80px'
            },
            { dataField: 'courseFullName', caption: $translate.instant('TXT_LBL_COURSE'), dataType: 'string' },
            {
                dataField: 'destinationSemesterCourseRegistrations',
                caption: $translate.instant('TXT_MENU_BOOKED_IN_DST_SEMESTER'),
                dataType: 'boolean',
                calculateCellValue: function (rowData) {
                    return !!rowData.destinationSemesterCourseRegistrations && rowData.destinationSemesterCourseRegistrations.length != 0;
                },
                width: '40px'
            },            
            {
                dataField: 'compensationGroupsIDs',
                caption: $translate.instant("TXT_MENU_COMPENSATION_GROUPS"),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('compensationGroups')(rowData.compensationGroupsIDs);
                },
                width: '240px'
            },
        ],
        onCellPrepared: function (e) {
            if (e.rowType === "data" && e.columnIndex == 4) {
                e.cellElement.mousemove(function () {
                    if (!!e.data.destinationSemesterCourseRegistrations) {
                        e.cellElement.attr('title', e.data.destinationSemesterCourseRegistrations.join('\n'));
                    }
                });
            }
        },
    }

    $scope.onCourseRegistrationRowEdit = function (d) {
        courseRegistrationDetailPromise.$promise.then(function () {
            courseRegistrationDetailPromise.$scope.model = d
            courseRegistrationDetailPromise.show();
        });
    }

    $scope.onPreferredBookingSave = function (model) {
        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;
        $scope.detailError = null;

        if (model.preferredBookingID) {
            preferredBookingSvc.update(model, success, error);
        } else {
            preferredBookingSvc.insert(model, success, error);
        }

        function success() {
            $scope.isSaving = false;

            if (!!$scope.onPreferredBookingSavedSuccessfully) {
                $scope.onPreferredBookingSavedSuccessfully(model);
            }
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }

    var courseRegistrationDetailPromise = $modal({
        templateUrl: 'setting/semesters/preferred-booking-course-registration-detail.html',
        show: false,
        scope: $scope.$new()
    });


}]);
